import { render } from "./CaptureView.vue?vue&type=template&id=3f14edee"
import script from "./CaptureView.vue?vue&type=script&lang=js"
export * from "./CaptureView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__